import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Promise } from "xlsx-populate";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Container,
} from "reactstrap";

// helpers
import { isValidCPF, isValidCNPJ } from "../../helpers/valid.js";

// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST } from "../../services/api_service.js";
import { InputCNPJ } from "../../services/mask.js";
import TextField from "../../components/TextField/TextField.jsx";
import mascaras from "../../helpers/mascaras.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function DadosPrimarios({ opcao }) {
  const { setLoading } = useAuth();

  const { register, handleSubmit, errors, setError, clearErrors, getValues } =
    useForm({ mode: "onBlur" });

  const [cpf_cnpj, setCpf_cnpj] = useState({
    valor: "",
  });

  const [errorCpfCnpj, setErrorCpf_cnpj] = useState(false);

  const [h1_tab, set_h1_tab] = useState("PJ");
  const [setupSolicitacaoAcaoPJ, set_setupSolicitacaoAcaoPJ] =
    React.useState(null);
  const [setupSolicitacaoAcaoPF, set_setupSolicitacaoAcaoPF] =
    React.useState(null);
  const [setupSolicitacaoAcaoPB, set_setupSolicitacaoAcaoPB] =
    React.useState(null);
  const [setupSolicitacaoAcaoPJMEI, set_setupSolicitacaoAcaoPJMEI] =
    React.useState(null);
  const [protocolo, set_protocolo] = React.useState(null);

  useEffect(() => {
    const options_h1 = [
      {
        option: "PJ",
        set: (data) => set_setupSolicitacaoAcaoPJ(data),
      },
      {
        option: "PB",
        set: (data) => set_setupSolicitacaoAcaoPB(data),
      },
      {
        option: "PF",
        set: (data) => set_setupSolicitacaoAcaoPF(data),
      },
      {
        option: "PJMEI",
        set: (data) => set_setupSolicitacaoAcaoPJMEI(data),
      },
    ];

    Promise.all([
      api_GET(
        `setupsolicitacao/GetByAcaoSegmentoCategoria/${opcao.segmento}/${opcao.categoria_Id}/Novo Cadastro/Jurídica`
      ).catch((err) => null),
      api_GET(
        `setupsolicitacao/GetByAcaoSegmentoCategoria/${opcao.segmento}/${opcao.categoria_Id}/Novo Cadastro/Pública`
      ).catch((err) => null),
      api_GET(
        `setupsolicitacao/GetByAcaoSegmentoCategoria/${opcao.segmento}/${opcao.categoria_Id}/Novo Cadastro/Física`
      ).catch((err) => null),
      api_GET(
        `setupsolicitacao/GetByAcaoSegmentoCategoria/${opcao.segmento}/${opcao.categoria_Id}/Novo Cadastro/Jurídica - MEI`
      ).catch((err) => null),
    ]).then((values) => {
      let index_h1 = -1;
      for (let index = 0; index < values.length; index++) {
        if (
          values[index] &&
          values[index].status === 200 &&
          values[index].data != null
        ) {
          options_h1[index].set(values[index].data);
          if (index_h1 === -1) {
            index_h1 = index;
          }
        }
      }

      if (index_h1 !== -1) {
        set_h1_tab(options_h1[index_h1].option);
      }
    });
  }, []);

  function handleTipoPessoa(tabSelecionando) {
    switch (tabSelecionando) {
      case "PJ":
        return "Pessoa Jurídica (Privado)";
      case "PB":
        return "Pessoa Jurídica (Público)";
      case "PJMEI":
        return "Pessoa Jurídica / MEI";
      default:
        return "Pessoa Física / MEI";
    }
  }

  function handleSolicitacaoAcao_Id(tabSelecionando) {
    switch (tabSelecionando) {
      case "PJ":
        return setupSolicitacaoAcaoPJ.setupSolicitacaoAcao_Id;
      case "PB":
        return setupSolicitacaoAcaoPB.setupSolicitacaoAcao_Id;
      case "PJMEI":
        return setupSolicitacaoAcaoPJMEI.setupSolicitacaoAcao_Id;
      default:
        return setupSolicitacaoAcaoPF.setupSolicitacaoAcao_Id;
    }
  }

  const onSubmit = (data) => {
    if (data.email != data.confirmarEmail) {
      showMessage(
        "Aviso",
        "O email e a confirmação de email não conferem!",
        "error",
        null
      );
      return;
    }

    if (h1_tab != "PF" && !isValidCNPJ(data.cnpj)) {
      showMessage("Aviso", "CNPJ inválido!", "error", null);
      return;
    }

    if (h1_tab == "PF" && cpf_cnpj.valor.trim().length == 0) {
      setErrorCpf_cnpj(true);
      return;
    }

    if (
      h1_tab == "PF" &&
      cpf_cnpj.valor.length > 11 &&
      !isValidCNPJ(cpf_cnpj.valor)
    ) {
      showMessage("Aviso", "CNPJ inválido!", "error", null);
      setErrorCpf_cnpj(true);
      return;
    }

    if (
      h1_tab == "PF" &&
      cpf_cnpj.valor.length <= 11 &&
      !isValidCPF(cpf_cnpj.valor)
    ) {
      showMessage("Aviso", "CPF inválido!!", "error", null);
      setErrorCpf_cnpj(true);
      return;
    }

    let tipoPessoa = handleTipoPessoa(h1_tab);
    let setupSolicitacaoAcao_Id = handleSolicitacaoAcao_Id(h1_tab);

    let json_submit = {
      requerimento_Id: 0,
      nomeSolicitante: h1_tab == "PF" ? data.nome : data.fantasia,
      email: data.email,
      cpf_Cnpj:
        h1_tab == "PF"
          ? cpf_cnpj.valor
          : data.cnpj
            .replaceAll("/", "")
            .replaceAll(".", "")
            .replaceAll("-", ""),
      protocolo_Id: 0,
      setupSolicitacaoAcao_Id: setupSolicitacaoAcao_Id,
      tipoPessoa: tipoPessoa,
      protocolo: {
        numeroProtocolo: "",
        nomeSolicitante: h1_tab == "PF" ? data.nome : data.fantasia,
        email: data.email,
        cpf_Cnpj:
          h1_tab == "PF"
            ? cpf_cnpj.valor
            : data.cnpj
              .replaceAll("/", "")
              .replaceAll(".", "")
              .replaceAll("-", ""),
        tipoPessoa: tipoPessoa,
        status: "Pendente",
        senha: Math.random().toString(36).slice(-8),
      },
    };

    setLoading(true);
    api_POST("Requerimento/PostRequerimentoProtocolo", json_submit)
      .then((result) => {
        setLoading(false);
        set_protocolo(result.data);
        showMessage(
          "Aviso",
          "Sua solicitação de cadastro foi criada com sucesso! Enviamos um e-mail contendo o link para completar o cadastro.",
          "success",
          null
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setCpf_cnpj({ [name]: value });
    setErrorCpf_cnpj(false);
  };

  return (
    <>
      <div className="content">
        <Card className="card-stats" style={{ margin: "50px auto" }}>
          <CardBody>
            {protocolo == null && (
              <Container style={{ maxWidth: "800px", margin: "20px auto" }}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <h2 className="titulo-solicitacao">Dados Primários</h2>
                  <h6 className="text-center">{opcao.descricao}</h6>
                  <Nav
                    pills
                    className="nav-pills-primary"
                    style={{ cursor: "pointer" }}
                  >
                    {setupSolicitacaoAcaoPJ != null && (
                      <NavItem>
                        <NavLink
                          className={
                            h1_tab === "PJ" ? "link-nav active" : "link-nav"
                          }
                          onClick={() => set_h1_tab("PJ")}
                        >
                          <i class="fas fa-building"></i> Pessoa Jurídica
                          (Privado)
                        </NavLink>
                      </NavItem>
                    )}
                    {setupSolicitacaoAcaoPB != null && (
                      <NavItem>
                        <NavLink
                          style={{ margin: "0px 10px" }}
                          className={
                            h1_tab === "PB" ? "link-nav active" : "link-nav"
                          }
                          onClick={() => set_h1_tab("PB")}
                        >
                          <i class="fas fa-university"></i> Pessoa Jurídica
                          (Público){" "}
                        </NavLink>
                      </NavItem>
                    )}
                    {setupSolicitacaoAcaoPF != null && (
                      <NavItem>
                        <NavLink
                          style={{ margin: "0px 10px" }}
                          className={
                            h1_tab === "PF" ? "link-nav active" : "link-nav"
                          }
                          onClick={() => set_h1_tab("PF")}
                        >
                          <i class="fas fa-address-card"></i> Pessoa Física{" "}
                        </NavLink>
                      </NavItem>
                    )}
                    {setupSolicitacaoAcaoPJMEI != null && (
                      <NavItem>
                        <NavLink
                          style={{ margin: "0px 10px" }}
                          className={
                            h1_tab === "PJMEI" ? "link-nav active" : "link-nav"
                          }
                          onClick={() => set_h1_tab("PJMEI")}
                        >
                          <i class="fas fa-address-card"></i> Pessoa Jurídica / MEI
                        </NavLink>
                      </NavItem>
                    )}
                  </Nav>
                  <TabContent
                    activeTab={h1_tab}
                    className="tab-space tab-principal"
                  >
                    <TabPane tabId="PJ">
                      {h1_tab == "PJ" && setupSolicitacaoAcaoPJ != null && (
                        <Row className="pt-2">
                          <Col md="12" lg="12">
                            <FormGroup>
                              <b>
                                <label>CNPJ</label>
                              </b>
                              <InputCNPJ
                                name="cnpj"
                                inputRef={register({ required: true })}
                              />
                              {errors.cnpj && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>Nome Responsável</label>
                              </b>
                              <Input
                                type="text"
                                maxLength="50"
                                name="fantasia"
                                innerRef={register({ required: true })}
                              />
                              {errors.fantasia && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>E-mail</label>
                              </b>
                              <Input
                                type="email"
                                maxLength="200"
                                name="email"
                                innerRef={register({ required: true })}
                              />
                              {errors.email && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>Confirmar E-mail</label>
                              </b>
                              <Input
                                type="email"
                                maxLength="200"
                                name="confirmarEmail"
                                innerRef={register({ required: true })}
                              />
                              {errors.confirmarEmail && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          {opcao.sigla == "RGG" && (
                            <Col md="12" lg="12" className="fw-bold">
                              <span className="text-danger fw-bold">
                                Atenção:{" "}
                              </span>
                              <span className="fw-bold text-dark">
                                Informe o e-mail do{" "}
                                {opcao && opcao.segmento?.toLowerCase()}. Esta
                                informação é ultilizada para acesso e operação
                                no sistema.
                              </span>
                            </Col>
                          )}
                        </Row>
                      )}
                    </TabPane>
                    <TabPane tabId="PJMEI">
                      {h1_tab == "PJMEI" && setupSolicitacaoAcaoPJMEI != null && (
                        <Row className="pt-2">
                          <Col md="12" lg="12">
                            <FormGroup>
                              <b>
                                <label>CNPJ</label>
                              </b>
                              <InputCNPJ
                                name="cnpj"
                                inputRef={register({ required: true })}
                              />
                              {errors.cnpj && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>Nome Responsável</label>
                              </b>
                              <Input
                                type="text"
                                maxLength="50"
                                name="fantasia"
                                innerRef={register({ required: true })}
                              />
                              {errors.fantasia && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>E-mail</label>
                              </b>
                              <Input
                                type="email"
                                maxLength="200"
                                name="email"
                                innerRef={register({ required: true })}
                              />
                              {errors.email && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>Confirmar E-mail</label>
                              </b>
                              <Input
                                type="email"
                                maxLength="200"
                                name="confirmarEmail"
                                innerRef={register({ required: true })}
                              />
                              {errors.confirmarEmail && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          {opcao.sigla == "RGG" && (
                            <Col md="12" lg="12" className="fw-bold">
                              <span className="text-danger fw-bold">
                                Atenção:{" "}
                              </span>
                              <span className="fw-bold text-dark">
                                Informe o e-mail do{" "}
                                {opcao && opcao.segmento?.toLowerCase()}. Esta
                                informação é ultilizada para acesso e operação
                                no sistema.
                              </span>
                            </Col>
                          )}
                        </Row>
                      )}
                    </TabPane>
                    <TabPane tabId="PB">
                      {h1_tab == "PB" && setupSolicitacaoAcaoPB != null && (
                        <Row className="pt-2">
                          <Col md="12" lg="12">
                            <FormGroup>
                              <b>
                                <label>CNPJ</label>
                              </b>
                              <InputCNPJ
                                name="cnpj"
                                inputRef={register({ required: true })}
                              />
                              {errors.cnpj && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>Nome Responsável</label>
                              </b>
                              <Input
                                type="text"
                                maxLength="50"
                                name="fantasia"
                                innerRef={register({ required: true })}
                              />
                              {errors.fantasia && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>E-mail</label>
                              </b>
                              <Input
                                type="email"
                                maxLength="200"
                                name="email"
                                innerRef={register({ required: true })}
                              />
                              {errors.email && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <b>
                                <label>Confirmar E-mail</label>
                              </b>
                              <Input
                                type="email"
                                maxLength="200"
                                name="confirmarEmail"
                                innerRef={register({ required: true })}
                              />
                              {errors.confirmarEmail && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          {opcao.sigla == "RGG" && (
                            <Col md="12" lg="12" className="fw-bold">
                              <span className="text-danger fw-bold">
                                Atenção:{" "}
                              </span>
                              <span className="fw-bold text-dark">
                                Informe o e-mail do{" "}
                                {opcao && opcao.segmento?.toLowerCase()}. Esta
                                informação é ultilizada para acess0 e operação
                                no sistema.
                              </span>
                            </Col>
                          )}
                        </Row>
                      )}
                    </TabPane>
                    <TabPane tabId="PF">
                      <div className="formPrincipal">
                        {h1_tab == "PF" && setupSolicitacaoAcaoPF != null && (
                          <Row className="pt-2">
                            <Col md="12" lg="12">
                              <FormGroup>
                                <b>
                                  <label>
                                    {cpf_cnpj?.valor?.length <= 12
                                      ? "CPF"
                                      : "CNPJ"}
                                  </label>
                                </b>
                                <TextField
                                  type="text"
                                  name="valor"
                                  mask={mascaras.cpfcnpjMask}
                                  value={cpf_cnpj.valor}
                                  onChange={onChange}
                                  maxLength={18}
                                />
                                {errorCpfCnpj && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                              <FormGroup>
                                <b>
                                  <label>Nome Responsável</label>
                                </b>
                                <Input
                                  type="text"
                                  maxLength="50"
                                  name="nome"
                                  innerRef={register({ required: true })}
                                />
                                {errors.nome && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                              <FormGroup>
                                <b>
                                  <label>E-mail</label>
                                </b>
                                <Input
                                  type="email"
                                  maxLength="200"
                                  name="email"
                                  innerRef={register({ required: true })}
                                />
                                {errors.email && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                              <FormGroup>
                                <b>
                                  <label>Confirmar E-mail</label>
                                </b>
                                <Input
                                  type="email"
                                  maxLength="200"
                                  name="confirmarEmail"
                                  innerRef={register({ required: true })}
                                />
                                {errors.confirmarEmail && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                            {opcao.sigla == "RGG" && (
                              <Col md="12" lg="12" className="fw-bold">
                                <span className="text-danger fw-bold">
                                  Atenção:{" "}
                                </span>
                                <span className="fw-bold text-dark">
                                  Informe o e-mail do Gerador. Esta informação é
                                  ultilizada para acesso e operação no sistema.
                                </span>
                              </Col>
                            )}
                          </Row>
                        )}
                      </div>
                    </TabPane>
                  </TabContent>
                  <Row>
                    <Col className="text-right">
                      <Button
                        color="success"
                        className="btn-mobile"
                        type="submit"
                      >
                        Próxima Etapa<i className="fas fa-chevron-right"></i>
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Container>
            )}
            {protocolo != null && (
              <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                <Row>
                  <Col md="12" lg="12" className="text-center">
                    <h3>Solicitação enviada com Sucesso</h3>
                    <br />
                    <h3>
                      Verifique sua caixa de email
                      <br /> para darmos continuidade no cadastro.
                    </h3>
                  </Col>
                </Row>
              </Container>
            )}
          </CardBody>
        </Card>
      </div>
    </>
  );
}
